export default {
  MuiAccordionDetails: {
    root: {
      padding: 0,
    },
  },
};
